import * as React from 'react';
import { JSX } from 'react/jsx-runtime';
const MapIconDark = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => (
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.65472 4.95C9.65472 3.7 8.65472 2.7 7.40472 2.7C6.15472 2.7 5.15472 3.7 5.15472 4.95C5.15472 6.2 6.15472 7.2 7.40472 7.2C8.65472 7.2 9.65472 6.2 9.65472 4.95ZM6.27972 4.95C6.27972 4.325 6.77972 3.825 7.40472 3.825C8.02972 3.825 8.52972 4.325 8.52972 4.95C8.52972 5.575 8.02972 6.075 7.40472 6.075C6.77972 6.075 6.27972 5.575 6.27972 4.95Z"
      fill="#EEF7FF"
    />
    <path
      d="M15.1047 14.15L14.0797 9.525C14.0297 9.3 13.8547 9.125 13.6047 9.1L10.6297 8.675C11.5797 7.325 12.3547 5.9 12.3547 4.8C12.3547 2.15 10.1297 0 7.40474 0C4.67974 0 2.45474 2.15 2.45474 4.8C2.45474 5.9 3.22974 7.325 4.17974 8.675L1.17974 9.1C0.929738 9.125 0.754737 9.325 0.704737 9.575L0.00473751 14.2C-0.0202625 14.4 0.0547375 14.6 0.204737 14.725C0.354738 14.85 0.554738 14.9 0.754738 14.825L4.05474 13.675L7.37974 14.8C7.50474 14.85 7.62974 14.85 7.72974 14.8L11.0547 13.675L14.3797 14.8C14.4297 14.825 14.5047 14.825 14.5547 14.825C14.6797 14.825 14.8297 14.775 14.9297 14.675C15.0797 14.575 15.1547 14.35 15.1047 14.15ZM7.40474 1.125C9.52974 1.125 11.2297 2.775 11.2297 4.8C11.2297 6.175 9.25474 8.8 7.40474 10.825C5.55474 8.825 3.57974 6.175 3.57974 4.8C3.57974 2.775 5.27974 1.125 7.40474 1.125ZM11.2297 12.55C11.1047 12.5 10.9797 12.5 10.8797 12.55L7.55474 13.675L4.22974 12.55C4.10474 12.5 3.97974 12.5 3.87974 12.55L1.25474 13.45L1.75474 10.175L4.92974 9.7C5.50474 10.425 6.10474 11.1 6.57974 11.625C6.77974 11.85 7.07974 11.975 7.37974 11.975C7.67974 11.975 7.97974 11.85 8.17974 11.625C8.65474 11.1 9.25474 10.425 9.82974 9.7L13.0797 10.175L13.8047 13.425L11.2297 12.55Z"
      fill="#EEF7FF"
    />
  </svg>
);
export default MapIconDark;
